import QueryCreditBundle from "graphql/queries/QueryCreditBundle";
import QueryCreditBundles from "graphql/queries/QueryCreditBundles";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder';

const FetchCreditBundles = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'credit_bundles', QueryCreditBundles, {
			variables: variables,
			resultPath: [ 'credit_bundles' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	},

	fetch: ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'credit_bundle', QueryCreditBundle, {
			variables: variables,
			resultPath: [ 'credit_bundle' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchCreditBundles
